"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _toggleButton = _interopRequireDefault(require("./toggle-button"));

var _reactPopper = require("react-popper");

var _outsideClick = _interopRequireDefault(require("./outside-click"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TimePicker =
/*#__PURE__*/
function (_Component) {
  _inherits(TimePicker, _Component);

  function TimePicker(props) {
    var _this;

    _classCallCheck(this, TimePicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimePicker).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (selectedButtonId) {
      if (selectedButtonId == "1") {
        _this.setState({
          isAm: true
        });
      } else {
        _this.setState({
          isAm: false
        });
      }
    });

    _this.state = {
      isOpen: false,
      isAm: true,
      hour: "",
      displayHour: "",
      minute: "",
      displayMinute: "",
      time: ""
    };
    return _this;
  }

  _createClass(TimePicker, [{
    key: "handleClick",
    value: function handleClick() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      this.setState({
        hour: "",
        minute: "",
        displayHour: "",
        displayMinute: "",
        time: "",
        isOpen: false
      });
    }
  }, {
    key: "show",
    value: function show() {
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: "collapse",
    value: function collapse() {
      this.setState({
        isOpen: false
      });
      this.formatHour();
      this.formatMinute();
    }
  }, {
    key: "incrementHour",
    value: function incrementHour() {
      if (this.state.hour) {
        if (this.state.hour < 9) {
          this.state.hour = this.state.hour + 1;
          this.state.displayHour = "0" + this.state.hour;
        } else if (this.state.hour < 12) {
          this.state.hour = this.state.hour + 1;
          this.state.displayHour = this.state.hour;
        } else {
          this.state.hour = 1;
          this.state.displayHour = "01";
        }
      } else {
        this.state.hour = 1;
        this.state.displayHour = "01";
      }

      this.setState({
        hour: this.state.hour,
        displayHour: this.state.displayHour
      });
      this.updateTime();
    }
  }, {
    key: "decrementHour",
    value: function decrementHour() {
      if (this.state.hour) {
        if (this.state.hour > 1 && this.state.hour < 11) {
          this.state.hour = this.state.hour - 1;
          this.state.displayHour = "0" + this.state.hour;
        } else if (this.state.hour > 1 && this.state.hour < 13) {
          this.state.hour = this.state.hour - 1;
          this.state.displayHour = this.state.hour;
        } else {
          this.state.hour = 12;
          this.state.displayHour = 12;
        }
      } else {
        this.state.hour = 12;
        this.state.displayHour = 12;
      }

      this.setState({
        hour: this.state.hour,
        displayHour: this.state.displayHour
      });
      this.updateTime();
    }
  }, {
    key: "incrementMinute",
    value: function incrementMinute() {
      if (this.state.minute || this.state.minute == 0) {
        if (this.state.minute == 0) {
          this.state.minute = 1;
          this.state.displayMinute = "01";
        } else {
          if (this.state.minute < 9) {
            this.state.minute = this.state.minute + 1;
            this.state.displayMinute = "0" + this.state.minute;
          } else if (this.state.minute < 59) {
            this.state.minute = this.state.minute + 1;
            this.state.displayMinute = this.state.minute;
          } else {
            this.state.minute = 0;
            this.state.displayMinute = "00";
          }
        }
      } else {
        this.state.minute = 0;
        this.state.displayMinute = "00";
      }

      this.setState({
        minute: this.state.minute,
        displayMinute: this.state.displayMinute
      });
      this.updateTime();
    }
  }, {
    key: "decrementMinute",
    value: function decrementMinute() {
      if (this.state.minute || this.state.minute == 0) {
        if (this.state.minute > 0 && this.state.minute < 11) {
          this.state.minute = this.state.minute - 1;
          this.state.displayMinute = "0" + this.state.minute;
        } else if (this.state.minute > 1 && this.state.minute < 60) {
          this.state.minute = this.state.minute - 1;
          this.state.displayMinute = this.state.minute;
        } else {
          this.state.minute = 59;
          this.state.displayMinute = 59;
        }
      } else {
        this.state.minute = 0;
        this.state.displayMinute = "00";
      }

      this.setState({
        minute: this.state.minute,
        displayMinute: this.state.displayMinute
      });
      this.updateTime();
    }
  }, {
    key: "updateTime",
    value: function updateTime() {
      if (this.state.displayMinute && this.state.displayHour) {
        this.setState({
          time: this.state.displayHour + ":" + this.state.displayMinute
        });
      } else {
        this.setState({
          time: ""
        });
      }
    }
  }, {
    key: "setHour",
    value: function setHour(event) {
      var hour = event.target.value;

      if (hour > 0 && hour < 13) {
        this.state.hour = parseInt(hour);
        this.state.displayHour = hour;
      } else {
        this.state.hour = "";
        this.state.displayHour = "";
      }

      this.setState({
        hour: this.state.hour,
        displayHour: this.state.displayHour
      });
    }
  }, {
    key: "formatHour",
    value: function formatHour() {
      if (this.state.hour < 10 && this.state.hour > 0) {
        this.state.displayHour = "0" + this.state.hour;
        this.setState({
          displayHour: this.state.displayHour
        });
      }

      this.updateTime();
    }
  }, {
    key: "setMinute",
    value: function setMinute(event) {
      var minute = event.target.value;

      if (minute == 0) {
        this.state.minute = parseInt(minute);
        this.state.displayMinute = minute;
      } else if (minute > 0 && minute < 60) {
        if (minute.startsWith("0") && minute > 9) {
          minute = minute.replace("0", "");
        }

        this.state.minute = parseInt(minute);
        this.state.displayMinute = minute;
      } else {
        this.state.minute = "";
        this.state.displayMinute = "";
      }

      this.setState({
        minute: this.state.minute,
        displayMinute: this.state.displayMinute
      });
    }
  }, {
    key: "formatMinute",
    value: function formatMinute() {
      if (this.state.minute != "" && this.state.minute < 10) {
        this.state.displayMinute = "0" + this.state.minute;
        this.setState({
          displayMinute: this.state.displayMinute
        });
      }

      this.updateTime();
    }
  }, {
    key: "getTime",
    value: function getTime() {
      if (this.state.time) {
        if (this.state.isAm) {
          return this.state.time + " AM";
        } else {
          return this.state.time + " PM";
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var buttons = [{
        id: 1,
        label: "AM",
        active: true
      }, {
        id: 2,
        label: "PM",
        active: false
      }];
      return _react.default.createElement("div", null, _react.default.createElement(_outsideClick.default, {
        clicked: function clicked() {
          return _this2.collapse();
        }
      }, _react.default.createElement(_reactPopper.Manager, null, _react.default.createElement(_reactPopper.Target, null, _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", null, this.props.title), _react.default.createElement("div", {
        className: "input-btn-wrapper"
      }, _react.default.createElement("input", {
        className: "form-control datepicker",
        value: this.state.time,
        placeholder: "hh:mm",
        onFocus: function onFocus() {
          return _this2.show();
        }
      }), _react.default.createElement("button", {
        type: "button",
        className: "select-btn date-picker-select-position",
        onClick: function onClick() {
          return _this2.handleClick();
        }
      }, _react.default.createElement("span", {
        className: "fa fa-clock-o"
      }))))), this.state.isOpen ? _react.default.createElement(_reactPopper.Popper, {
        placement: "bottom-end",
        class: "time-popper-container"
      }, _react.default.createElement("div", null, _react.default.createElement("div", {
        className: "time-picker-cotent"
      }, _react.default.createElement("div", {
        className: "time-picker-up-btns"
      }, _react.default.createElement("span", null, _react.default.createElement("button", {
        type: "button",
        className: "increment-btn time-picker-spacer",
        onClick: function onClick() {
          return _this2.incrementHour();
        }
      }, _react.default.createElement("span", {
        className: "fa fa-angle-up increment-icon"
      }))), _react.default.createElement("span", null, _react.default.createElement("button", {
        type: "button",
        className: "increment-btn",
        onClick: function onClick() {
          return _this2.incrementMinute();
        }
      }, _react.default.createElement("span", {
        className: "fa fa-angle-up increment-icon"
      })))), _react.default.createElement("div", {
        className: "time-picker-time-inputs"
      }, _react.default.createElement("table", {
        cellPadding: "0",
        cellSpacing: "0",
        className: "time-picker-table"
      }, _react.default.createElement("tr", null, _react.default.createElement("td", null, _react.default.createElement("div", {
        className: "time-picker-input"
      }, _react.default.createElement("input", {
        value: this.state.displayHour,
        type: "text",
        className: "time-input",
        placeholder: "hh",
        onChange: this.setHour.bind(this),
        onBlur: function onBlur() {
          return _this2.formatHour();
        }
      }))), _react.default.createElement("td", null, _react.default.createElement("div", {
        className: "time-devider"
      }, ":")), _react.default.createElement("td", null, _react.default.createElement("div", {
        className: "time-picker-input"
      }, _react.default.createElement("input", {
        value: this.state.displayMinute,
        className: "time-input",
        placeholder: "mm",
        onChange: this.setMinute.bind(this),
        onBlur: function onBlur() {
          return _this2.formatMinute();
        }
      }))), _react.default.createElement("td", null, _react.default.createElement("div", {
        className: "time-picker-am-pm"
      }, _react.default.createElement(_toggleButton.default, {
        id: "ampm",
        size: "regular",
        buttons: buttons,
        onChange: this.onChange
      })))))), _react.default.createElement("div", null, _react.default.createElement("span", null, _react.default.createElement("button", {
        type: "button",
        className: "increment-btn time-picker-spacer",
        onClick: function onClick() {
          return _this2.decrementHour();
        }
      }, _react.default.createElement("span", {
        className: "fa fa-angle-down increment-icon"
      }))), _react.default.createElement("span", null, _react.default.createElement("button", {
        type: "button",
        className: "increment-btn",
        onClick: function onClick() {
          return _this2.decrementMinute();
        }
      }, _react.default.createElement("span", {
        className: "fa fa-angle-down increment-icon"
      }))))), _react.default.createElement("div", {
        className: "time-picker-bottom-container"
      }, _react.default.createElement("a", {
        className: "time-picker-clear",
        onClick: function onClick() {
          return _this2.clear();
        }
      }, "Clear")))) : "")));
    }
  }]);

  return TimePicker;
}(_react.Component);

var _default = TimePicker;
exports.default = _default;